module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0136.jpg?v=6ef5469e";